export const DsAvatarGroupOverrides = {};
